import React from "react";

import type { ISession } from "@mne-authentication/api";

import type { IntlShape } from "@mnemonic/intl";
import type { TArgusLocale } from "@mnemonic/mui";
import { CoreMuiProvider, createArgusTheme } from "@mnemonic/mui";

export interface IThemeProviderProps {
  children: React.ReactNode;
  intl: IntlShape;
  session: ISession;
}

export default function ThemeProvider({ children, intl, session }: IThemeProviderProps) {
  /* Disabling dark mode in swagger until we have a solution that looks better */
  const sessionWithLightMode: ISession = {
    ...session,
    user: { ...session?.user, properties: { ...session?.user?.properties, "ui.themeMode": "light" } },
  };

  const theme = createArgusTheme(sessionWithLightMode, (createTheme, localizationOpts) =>
    createTheme(
      // Pass a empty object if there are no local overrides
      {},
      ...localizationOpts,
    ),
  );
  return (
    <CoreMuiProvider locale={intl?.locale as TArgusLocale} domain={session?.user?.domain} theme={theme}>
      {children}
    </CoreMuiProvider>
  );
}
